import { DefaultNodeData } from "@zapier/canvas-state";
import { ASSET_APP_IDS } from "@zapier/canvas-constants";

export const isAssetNode = (data: DefaultNodeData): boolean => {
  const appId = data.services?.[0]?.currentImplementation.id ?? "";
  return Object.values(ASSET_APP_IDS).some((identifier) =>
    appId.includes(identifier),
  );
};
